
































































export default function (Component) {
  Component.options.__source = "src/module/master-data/views/cmp-md-attr-viewer/cmp-md-attr-value-viewer.vue"
}
